export default "__VITE_ASSET__DzD5b3vx__"